export enum NavbarButtons {
    PHONES = 'Phones',
    GROUPS = 'Groups',
    ACTIVATE = 'Activate',
    LOGOUT = 'Logout',
}